import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface FeatureGuideState {
  // localStorage persisted (only dismissed state)
  dismissedGuides: Record<string, boolean>

  // Runtime state (not persisted)
  isOpen: boolean
  activeFeature: string | null

  openGuide: (featureKey: string) => void
  closeGuide: () => void
  dismissGuide: (featureKey: string) => void
  isDismissed: (featureKey: string) => boolean
}

export const useFeatureGuideStore = create<FeatureGuideState>()(
  persist(
    (set, get) => ({
      dismissedGuides: {},
      isOpen: false,
      activeFeature: null,

      openGuide: (featureKey: string) => {
        set({ isOpen: true, activeFeature: featureKey })
      },

      closeGuide: () => {
        set({ isOpen: false, activeFeature: null })
      },

      dismissGuide: (featureKey: string) => {
        set((state) => ({
          dismissedGuides: { ...state.dismissedGuides, [featureKey]: true },
        }))
      },

      isDismissed: (featureKey: string) => {
        return !!get().dismissedGuides[featureKey]
      },
    }),
    {
      name: 'feature-guide-storage',
      partialize: (state) => ({
        dismissedGuides: state.dismissedGuides,
      }),
    }
  )
)
